"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableTracking = exports.trackEvent = exports.TrackingHeadScript = void 0;
var TrackingHeadScript_1 = require("./components/TrackingHeadScript");
Object.defineProperty(exports, "TrackingHeadScript", { enumerable: true, get: function () { return __importDefault(TrackingHeadScript_1).default; } });
var react_gtm_1 = require("@phntms/react-gtm");
Object.defineProperty(exports, "trackEvent", { enumerable: true, get: function () { return react_gtm_1.trackEvent; } });
Object.defineProperty(exports, "enableTracking", { enumerable: true, get: function () { return react_gtm_1.enableTracking; } });
//# sourceMappingURL=index.js.map